import {ITheme} from 'contexts/ThemeContext';
import {useWindowDimensions} from 'react-native';

export default ({colors, typography}: ITheme) => {
  const {width, height} = useWindowDimensions();

  return {
    itemContainerStyle: {
      paddingHorizontal: 16,
      paddingVertical: 11,
    },
    selectedItemContainerStyle: {
      paddingHorizontal: 16,
      paddingVertical: 11,
      backgroundColor: colors.alabaster,
    },
    itemSeparator: {},
    optionTextStyle: {
      fontSize: 16,
      lineHeight: 24,
      color: colors.primaryTextColor,
      ...typography.interRegular,
    },
    selectedTextStyle: {
      fontSize: 16,
      lineHeight: 24,
      color: colors.cornflowerBlue,
      ...typography.interRegular,
    },
  };
};
